import type { PaymentStore } from '../domain/types'
import { useStoreWithEqualityFn } from 'zustand/traditional'
import { paymentStore } from './store'

export function usePaymentStore<T>(
  selector: (state: PaymentStore) => T,
  equalityFn?: (a: T, b: T) => boolean,
): T {
  return useStoreWithEqualityFn(paymentStore, selector, equalityFn)
}
